<template>
  <v-container class="pt-5 pb-2">
    <h1 v-if="this.resume.name" class="name">
      {{ this.resume.name }}
    </h1>
    <p v-if="this.resume.about" class="about">
      {{ this.resume.about }}
    </p>
  </v-container>
</template>

<script>
import { mapState } from "pinia";
import { useCreateResumeStore } from "@/modules/create_resume/store/CreateResumeStore";
export default {
  computed: {
    ...mapState(useCreateResumeStore, ["resume"]),
  },
};
</script>

<style>
.name {
  font-size: 45px;
  font-weight: bold;
}
.about {
  opacity: 0.8;
}
</style>
